import React from 'react';
import * as yup from 'yup';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';
import useTranslation from '../../../../../Hooks/useTranslation';
import Text from '../../../../../Components/Base/Text/Text';
import moment from 'moment';

//@ts-ignore
import styles from './ElectronicDPNCancellation.module.scss';

interface Props {
	onSubmit: (
		values: ElectronicDPNCancellationValues,
	) => void;
	electronicConfirmation?: any;
}

export interface ElectronicDPNCancellationValues {
	reason: string;
}

const ElectronicDPNCancellation: React.FC<Props> = props => {
	const {
		onSubmit,
		electronicConfirmation
	} = props;
	const { t } = useTranslation();

	const validationSchema = yup.object({
		reason: yup
			.string()
			.required(
				t(
					'nczi.electronicDPNCancellation.reasonValidationMessage',
				),
			),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = (values: any) => {
		onSubmit(values as ElectronicDPNCancellationValues);
	};

	const cancelConfirmation = electronicConfirmation.capableFrom ? 'nczi.electronicDPNCancellation.confirmationAfterEnd' : 'nczi.electronicDPNCancellation.confirmation';
	const issueDate = new Date(electronicConfirmation.issueDate);
	const isOtherMonth = (new Date()).getMonth() != issueDate.getMonth() || (new Date()).getFullYear() != issueDate.getFullYear();

	return (
		<FormWrapper formMethods={formMethods}>
			<Text tx={cancelConfirmation} />
			{isOtherMonth && <Text tx={'nczi.electronicDPNCancellation.confirmationOtherMonth'} className={styles.otherMonth} />}
			<br />
			<InputWrapper>
				<InputField
					name='reason'
					label='nczi.electronicDPNCancellation.reason'
					isRequired
				/>
			</InputWrapper>
			<SubmitButton onSubmit={handleSubmit} />
		</FormWrapper>
	);
};

export default ElectronicDPNCancellation;
